var currentKey = "";
var pagewidth = window.innerWidth;

document.addEventListener("DOMContentLoaded", function() {

    const urlParams = new URLSearchParams(window.location.search);
    const pilarToLoad = urlParams.get('pillar'); // Detecta "renew"
    const productTarget = urlParams.get('product');
    const targetAnchor = window.location.hash;    // Detecta "#january"

    if (pilarToLoad) 
    {
        const pillarSelected = pillarData[pilarToLoad.toUpperCase()];
        loadData(pillarSelected.key, pillarSelected.id).then(() => {

            if(productTarget)
                activateProductByHandle(productTarget);

            const targetElement = $(targetAnchor);
            if(targetElement.length == 0)
                return;

            $(targetAnchor)[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });



        });
    }

    $("#pillars .regen-link").on('mouseenter', function (e){

        if(this.dataset.index === undefined)
        {
            const Name = this.dataset.name;
            clarity("set", "Pillar_Hover", Name);
        }

    });

    $("#pillars .regen-link").on('click', function (e){
        e.preventDefault();

        const targetUrl = this.getAttribute('href');
        window.history.pushState({ path: targetUrl }, '', targetUrl);

        console.log(this.dataset);

        const key = this.dataset.key;
        const id = this.dataset.id;
        const Name = this.dataset.name;

        clarity("set", "Pillar_Click", Name);

        if(this.dataset.index)
        {
            switchPilar(this.dataset.index, key, id);
        }else
            selectPilar(this.children[0], key, id);

    });

    $("#pillars").on('mouseenter', function(e)
    {
        console.log('enter');
        $("#current_pillar").removeClass('current');
    });

    $("#pillars").on('mouseleave', function(e)
    {
         $("#current_pillar").addClass('current');
    });

});

window.addEventListener('resize', () => {
    pagewidth = window.innerWidth;
    console.log("El nuevo ancho es: " + pagewidth);
    
    if (pagewidth < 768) {
        console.log("Estamos en modo móvil");
    }
});

function clickProduct(mounth)
{
    clarity("set", "Regenerative_product_click", mounth);
}

function activateProductByHandle(handle) {
  // 1. Buscamos todos los elementos que coincidan con ese handle en toda la página
  const targetElements = document.querySelectorAll(`[data-product-handle="${handle}"]`);

  if (targetElements.length === 0) {
    console.warn(`No se encontró ningún producto con el handle: ${handle}`);
    return;
  }

  // 2. Buscamos todas las secciones de showcase para limpiar los estados activos previos
  // Esto asegura que si el handle existe en múltiples secciones, todas se actualicen
  const allShowcaseContainers = document.querySelectorAll('.product-showcase-container');

  allShowcaseContainers.forEach(container => {
    // Quitamos la clase 'is-active' de cualquier elemento activo previo en esta sección
    container.querySelectorAll('.main-content-item.is-active, .sidebar-item.is-active')
      .forEach(el => el.classList.remove('is-active'));
  });

  // 3. Activamos los nuevos elementos
  targetElements.forEach(el => {
    el.classList.add('is-active');
  });
}

function setEntry(e)
{
    const el = $(e);

    const wrapper = el.parent().parent();
    
    wrapper.find('.regen-entry-row').removeClass('active');
    wrapper.find(`.regen-entry-row[data-index="${el.data('target')}"]`).addClass('active');
    wrapper.find('.regen-entries-controls a').removeClass('active');
    el.addClass('active');
}

function moveEntry(e, direction = "next")
{
    const $wrapper = $(e).parent().parent();
    const $slides = $wrapper.find('.regen-entry-row'); // Ajusta el selector de tus hijos
    const $current = $slides.filter('.regen-entry-row.active');
    const bullets = $wrapper.find(".regen-entries-controls a");
    const currentBullet = $wrapper.find(".regen-entries-controls a.active");

    let $target;
    let targetBullet;

    if (direction === 'next') {
        $target = $current.next();
        targetBullet = currentBullet.next();
        // Si no hay siguiente, vuelve al primero (loop)
        if ($target.length === 0) {
            $target = $slides.first();
            targetBullet =  bullets.first();
        }
    } else {
        $target = $current.prev();
        targetBullet = currentBullet.prev();
        // Si no hay anterior, va al último (loop)
        if ($target.length === 0){
            $target = $slides.last();
            targetBullet =  bullets.last();
        } 
    }

    // Cambiar clases y ejecutar la lógica de movimiento
    $current.removeClass('active');
    $target.addClass('active');
    currentBullet.removeClass('active');
    targetBullet.addClass('active');
}


function  selectPilar(e, key , id)
{
    return new Promise(resolve => {

        const el = $(e);

        if(currentKey == key)
            return

        currentKey = key;

        loadData(key, id).then(resolve);

        $("#current_pillar").removeClass('current');
        $('.regen-card').removeClass('selected');

        if(pagewidth > 768)
            $('.regen-cards-container').addClass('transition');

        el.addClass('selected');
        $('.regen-column').removeClass('expanded');

        setTimeout(() => {

            $('.regen-cards-container').addClass('open');

            if(pagewidth > 768)
                $('.regen-cards-container').removeClass('transition');

            el.parent().parent().addClass('expanded');

        }, 500);
    })
}


function switchPilar(index, key , id)
{
    if(currentKey == key)
        return

    currentKey = key;
    loadData(key, id);

    const pilars = $('.regen-cards-container .regen-column');
    pilars.removeClass('expanded');
    $('.regen-card').removeClass('selected');
    const pilar = $(pilars[index]);
    pilar.addClass('expanded');
    pilar.children(0).children(0).addClass('selected');
}


function openShortcuts(id)
{
    $('#regen-shortcuts').show();
    $('#regen-shortcuts > .regen-card').removeClass('hidden');
    $(`#shortcut-${id}`).addClass('hidden');
}


function openShortcut(index, key, id)
{
    document.getElementById("pillars").scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });

    switchPilar(index, key, id);
}

function goToPillarInfo()
{
    clarity("set", "CTA_MAIN", "Click");
    document.getElementById("pillars-header").scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

/**
 * Carga secciones de forma dinámica y escalable.
 * @param {string} key - Preview key para la API.
 * @param {string} id - ID base de las secciones.
 * @param {Array} topics - Lista de sufijos a cargar (ej: ['topic_3', 'topic_2', 'topic_1', 'products'])
 */
async function loadData(key, id)
{ 
    const itemChunks = [
        ['topic_3', 'products_3'],
        ['topic_2', 'products_2'],
        ['topic_1', 'products_1']
    ];

    $('#regen-articles').html('');
    $('#regen-shortcuts').hide();

    let shortcuts_opened = false;

    for (const chunk of itemChunks) {
        const sectionKeys = chunk.map(topic => `${id}__${topic}`);
        const sectionsQuery = sectionKeys.join(',');

        try {
            const response = await fetch(`/pages?preview_key=${key}&sections=${sectionsQuery}`);
            const sectionsData = await response.json();
            
            sectionKeys.forEach(fullKey => {
                const content = sectionsData[fullKey];
                if (content) {
                    $('#regen-articles').append(content);
                }
            });

            if (!shortcuts_opened) {
                if (sectionsData[sectionKeys[0]]) { 
                    openShortcuts(key);
                    shortcuts_opened = true;
                }
            }

        } catch (error) {
            console.error(`Error cargando las secciones (${sectionsQuery}):`, error);
        }
    }
    
    // Al llegar aquí, la función termina y la promesa se resuelve automáticamente
}

/**
 * Crea un carrusel infinito moviendo el último hijo al principio.
 * @param {string} containerSelector - El ID o Clase del contenedor padre.
 * @param {number} intervalTime - Tiempo en ms (ej. 3000 para 3 segundos).
 */
function startInfiniteCarousel(container, intervalTime) {

    if (!container || container.children.length < 2) return;

    setInterval(() => {
        // 1. Identificamos al último hijo en ese instante
        const lastChild = container.lastElementChild;

        // 2. Aplicamos una pequeña transición de opacidad (opcional)
        lastChild.style.opacity = '0';

        setTimeout(() => {
            // 3. Lo movemos al inicio del contenedor
            container.prepend(lastChild);
            
            // 4. Lo volvemos a mostrar
            lastChild.style.opacity = '1';
        }, 300); // Tiempo de la transición
        
    }, intervalTime);
}
